export const categories = [
  { slug: 'wanghong-tafang', name: '网红塌房', description: '网红人设崩塌、翻车现场全记录', icon: 'ri-alert-line' },
  { slug: 'fansha-shipin', name: '反差视频', description: '博主台前幕后反差名场面', icon: 'ri-contrast-2-line' },
  { slug: 'bagua-neimu', name: '八卦内幕', description: '圈内人独家内幕深度揭秘', icon: 'ri-spy-line' },
  { slug: 'geren-shenghuo', name: '私生活', description: '网红私生活真实面貌大公开', icon: 'ri-eye-line' },
  { slug: 'pingtai-fengbo', name: '平台风波', description: '各大平台争议事件追踪', icon: 'ri-global-line' },
  { slug: 'fensi-zhengzhi', name: '粉丝争执', description: '饭圈大战、粉丝互撕全记录', icon: 'ri-fire-line' },
];

export const newsArticles = [
  {
    id: 1,
    title: '某千万粉丝博主被曝私下辱骂工作人员，人设崩塌引全网热议',
    excerpt: '近日，一位拥有超过两千万粉丝的知名博主被前工作人员实名爆料，称其在直播之外频繁对团队进行言语霸凌，与镜头前温暖阳光的形象形成鲜明对比。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20spotlight%20on%20a%20shattered%20smartphone%20screen%20reflecting%20a%20distressed%20face%2C%20crimson%20and%20black%20tones%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20dark%20atmospheric%20background&width=800&height=600&seq=news-hero-01&orientation=landscape',
    category: 'wanghong-tafang',
    author: '黑料特工小K',
    publishDate: '2026-07-06',
    readCount: 1289000,
    tags: ['网红塌房', '人设崩塌', '直播翻车'],
    content: [
      { type: 'heading', text: '事件始末' },
      { type: 'paragraph', text: '据知情人透露，这位以"暖男"人设走红的博主，在直播镜头之外完全是另一副面孔。前工作人员小李（化名）在接受本网独家采访时表示，自己在该团队工作了近两年时间，期间亲眼目睹了无数次令人震惊的场景。' },
      { type: 'paragraph', text: '"他在直播时会微笑着对粉丝说\'家人们我爱你们\'，但一下播就会变脸，对助理大吼大叫，甚至摔东西。"小李回忆道，"有一次因为直播间灯光没调好，他直接把价值上万的补光灯踢翻了，然后指着灯光师骂了整整二十分钟。"' },
      { type: 'heading', text: '证据链完整' },
      { type: 'paragraph', text: '爆料者提供了多段录音和聊天记录截图作为证据。在其中一段录音中可以清晰听到该博主用极其粗鄙的语言责骂团队成员。此外，还有多名前员工在社交媒体上发声，证实了类似的情况。' },
      { type: 'paragraph', text: '目前，该博主的社交媒体账号评论区已被网友"攻陷"，大量粉丝表示"滤镜碎了"、"脱粉了"。相关话题在各大平台热搜榜上持续霸榜超过12小时。' },
      { type: 'heading', text: '业内反应' },
      { type: 'paragraph', text: '多位业内人士对此事发表了看法。知名MCN机构负责人表示，网红行业确实存在"人设管理"的问题，但无论如何都不应该以牺牲他人尊严为代价。呼吁行业建立更完善的从业者权益保护机制。' },
      { type: 'paragraph', text: '截至发稿时，该博主方面尚未对此事作出任何回应。本网将持续关注事件进展。' },
    ],
  },
  {
    id: 2,
    title: '某知名美食博主被曝外卖摆拍，背后团队操作曝光',
    excerpt: '一位拥有八百万粉丝的美食测评博主被网友扒出，其"探店"视频均为提前安排好的商业合作，且大量使用外卖食品伪装堂食进行摆拍。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20photography%20setup%20with%20ring%20lights%20and%20a%20phone%20on%20tripod%2C%20takeout%20containers%20being%20styled%20to%20look%20like%20restaurant%20plating%2C%20dark%20moody%20atmosphere%20with%20crimson%20accents%2C%20editorial%20documentary%20style%20photography%2C%20cinematic%20lighting&width=800&height=600&seq=news-hero-02&orientation=landscape',
    category: 'fansha-shipin',
    author: '吃瓜前线阿喵',
    publishDate: '2026-07-05',
    readCount: 987000,
    tags: ['反差视频', '美食博主', '摆拍造假'],
    content: [
      { type: 'heading', text: '爆料曝光' },
      { type: 'paragraph', text: '事情的起因是有细心网友发现，该美食博主在不同视频中"探店"的餐桌背景惊人相似，甚至在多个号称"现场探店"的视频中出现了完全相同的餐具摆放方式。' },
      { type: 'paragraph', text: '经过深入调查，网友发现该博主所谓的"随机探店"其实都是在固定场地拍摄的，食物大多来自附近的外卖，经过精心摆盘后冒充堂食出品。甚至连"路人反应"都是雇来的群演。' },
      { type: 'heading', text: '真相揭露' },
      { type: 'paragraph', text: '有知情外卖骑手向本网爆料，称该博主团队每周固定时间会下大额外卖订单，要求送到指定的拍摄场地。"有时候一次性点十几家店的外卖，然后全部倒出来重新装盘，简直是在浪费食物。"该骑手表示。' },
      { type: 'heading', text: '后续影响' },
      { type: 'paragraph', text: '事件发酵后，多家与该博主合作的餐饮品牌纷纷宣布终止合作。该博主的粉丝数在一周内暴跌超过200万，成为今年美食圈最大的翻车事件之一。' },
    ],
  },
  {
    id: 3,
    title: '热门综艺选手私下关系曝光：台上姐妹情深，台下明争暗斗',
    excerpt: '某热门选秀综艺的多名选手被爆私下关系紧张，节目中的"姐妹情"全是剧本，真实情况令人大跌眼镜。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Backstage%20tension%20between%20performers%2C%20dramatic%20split%20lighting%2C%20one%20side%20warm%20one%20side%20cold%2C%20dark%20atmosphere%2C%20editorial%20photography%2C%20high%20fashion%20style%2C%20deep%20crimson%20and%20shadow%20tones&width=800&height=600&seq=news-hero-03&orientation=landscape',
    category: 'bagua-neimu',
    author: '圈内老炮儿',
    publishDate: '2026-07-04',
    readCount: 756000,
    tags: ['八卦内幕', '综艺黑幕', '选秀节目'],
    content: [
      { type: 'heading', text: '幕后真相' },
      { type: 'paragraph', text: '随着节目进入白热化阶段，越来越多的内幕被曝光。据节目组内部人员透露，选手们在镜头前的互动几乎全部按照剧本执行，台下的真实关系与观众看到的截然不同。' },
      { type: 'paragraph', text: '"有一组被称为最佳闺蜜的选手，实际上在后台几乎不说话。有次因为化妆间安排问题，两人直接在走廊上吵了起来，把工作人员都吓坏了。"该内部人员说道。' },
      { type: 'heading', text: '制作方操作' },
      { type: 'paragraph', text: '更令人震惊的是，制作方刻意制造选手之间的矛盾来制造话题。据称，有专门的编剧团队负责设计选手之间的"冲突剧情"，包括刻意安排不公平的赛制来引发选手之间的对立情绪。' },
    ],
  },
  {
    id: 4,
    title: '知名情侣博主分手内幕：表面和平分手实为出轨撕破脸',
    excerpt: '一对在社交媒体上拥有超过三千万粉丝的情侣博主突然官宣分手，表面称"和平分开"，但多方消息源证实分手原因实为男方出轨。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%2C%20shattered%20glass%20effect%2C%20dark%20dramatic%20scene%2C%20two%20silhouettes%20walking%20away%20from%20each%20other%2C%20moody%20crimson%20atmosphere%2C%20cinematic%20editorial%20photography%2C%20emotional%20depth&width=800&height=600&seq=news-hero-04&orientation=landscape',
    category: 'geren-shenghuo',
    author: '黑料特工小K',
    publishDate: '2026-07-03',
    readCount: 2350000,
    tags: ['私生活', '情侣博主', '出轨'],
    content: [
      { type: 'heading', text: '分手官宣引发震动' },
      { type: 'paragraph', text: '7月3日凌晨，这对被誉为"神仙眷侣"的情侣博主几乎同时发布分手声明，称经过"深思熟虑"决定分开，今后仍是朋友。声明措辞克制平静，看似一场体面的告别。然而，随后爆出的内幕却让这场分手变得石破天惊。' },
      { type: 'heading', text: '出轨证据' },
      { type: 'paragraph', text: '据接近女方的知情人士透露，分手的真正原因是男方在长达半年多的时间里与多名女性保持暧昧关系，其中至少有两段关系被证实发生在两人同居期间。' },
      { type: 'paragraph', text: '更有爆料称，男方出轨对象中包括一位同在网红圈的知名女主播。两人被多次拍到深夜出入同一家酒店，且有酒店入住记录为证。' },
      { type: 'heading', text: '商业影响' },
      { type: 'paragraph', text: '这对CP是多个顶级品牌的代言人，此次分手事件预计将给相关品牌带来巨大的公关危机。据业内人士估算，两人共同代言的品牌总价值超过五千万，目前已有品牌方紧急开会商讨应对方案。' },
    ],
  },
  {
    id: 5,
    title: '短视频平台算法黑幕曝光：特定账号被刻意限流打压',
    excerpt: '多名创作者联合发声，指控某头部短视频平台存在人为干预算法、刻意打压特定创作者的流量分配机制。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20algorithm%20visualization%20with%20chains%20and%20locks%2C%20dark%20tech%20aesthetic%2C%20crimson%20glowing%20data%20streams%20being%20blocked%2C%20cyberpunk%20inspired%20mood%2C%20editorial%20tech%20photography&width=800&height=600&seq=news-hero-05&orientation=landscape',
    category: 'pingtai-fengbo',
    author: '数据侦探老张',
    publishDate: '2026-07-02',
    readCount: 654000,
    tags: ['平台风波', '算法黑幕', '短视频'],
    content: [
      { type: 'heading', text: '创作者集体发声' },
      { type: 'paragraph', text: '近日，超过五十位创作者联合发布公开信，指控某头部短视频平台存在严重的流量分配不公问题。他们提供的后台数据显示，在内容质量和发布频率没有明显变化的情况下，部分账号的推荐流量出现了断崖式下跌。' },
      { type: 'paragraph', text: '"我的后台数据曲线简直就像是被人用刀切了一样，从某一天开始突然少了90%的推荐流量。"一位拥有五百万粉丝的创作者表示，"而且这不是个例，我认识的好几个朋友都遇到了同样的情况。"' },
      { type: 'heading', text: '平台回应' },
      { type: 'paragraph', text: '对此，平台方回应称流量波动属于正常现象，不存在所谓的"限流黑名单"。但这一说法并未得到创作者的认可，事件仍在持续发酵中。' },
    ],
  },
  {
    id: 6,
    title: '两位头部主播隔空互怼升级，背后MCN公司暗中角力',
    excerpt: '直播带货圈两大顶流主播在社交平台上连续多日隔空互怼，粉丝群体激烈交锋，知情人士称背后实为MCN公司之间的商业博弈。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20opposing%20sides%20represented%20by%20dramatic%20lighting%2C%20boxing%20ring%20metaphor%2C%20social%20media%20icons%20in%20conflict%2C%20dark%20atmospheric%20scene%2C%20crimson%20and%20shadow%20aesthetic%2C%20editorial%20sports%20photography%20style&width=800&height=600&seq=news-hero-06&orientation=landscape',
    category: 'fensi-zhengzhi',
    author: '圈内老炮儿',
    publishDate: '2026-07-01',
    readCount: 1890000,
    tags: ['粉丝争执', '主播互怼', 'MCN'],
    content: [
      { type: 'heading', text: '事件起因' },
      { type: 'paragraph', text: '事情的导火索是其中一位主播在直播中暗讽另一位主播"卖假货"，虽然没有指名道姓，但暗示的内容与对方的选品高度吻合。随后，被暗指的主播在次日的直播中进行了强硬回击，称对方"嫉妒自己的销量"。' },
      { type: 'heading', text: '粉丝大战' },
      { type: 'paragraph', text: '两位主播的粉丝群体随后在各大社交平台上展开了激烈的"战争"，相关话题多次登上热搜。双方的超话社区出现了大量互相攻击的内容，甚至出现了有组织的"出征"行为。' },
      { type: 'paragraph', text: '据业内人士分析，这场看似粉丝自发的冲突，背后实际上是两家MCN公司的商业博弈。两家公司在多个垂类领域存在直接竞争关系，此次冲突可能是有意策划的营销事件。' },
    ],
  },
];

export const exclusiveNews = [
  {
    id: 101,
    title: '独家：某顶流男星与经纪人',
    titleHighlight: '不可告人的秘密协议',
    quote: '这份协议的内容令人震惊，它揭示了一个精心设计的"人设工程"，涵盖了从恋爱到家庭关系的全方位包装方案。',
    source: '匿名知情人士',
    imageUrl: 'https://readdy.ai/api/search-image?query=Confidential%20document%20under%20dramatic%20spotlight%2C%20dark%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20crimson%20tones%2C%20high%20contrast%20editorial%20photography&width=600&height=750&seq=exclusive-01&orientation=portrait',
    category: 'bagua-neimu',
  },
  {
    id: 102,
    title: '深挖：某选秀节目投票',
    titleHighlight: '数据造假全链条',
    quote: '从投票系统到结果公示，每一个环节都存在人为操纵的痕迹，这已经不是简单的"剧本"问题，而是赤裸裸的商业欺诈。',
    source: '前节目组技术人员',
    imageUrl: 'https://readdy.ai/api/search-image?query=Manipulated%20data%20screens%20with%20glitch%20effects%2C%20dark%20tech%20noir%20aesthetic%2C%20crimson%20digital%20corruption%2C%20dramatic%20editorial%20photography%2C%20mysterious%20hacker%20atmosphere&width=600&height=750&seq=exclusive-02&orientation=portrait',
    category: 'pingtai-fengbo',
  },
  {
    id: 103,
    title: '揭秘：某知名品牌与',
    titleHighlight: 'KOL虚假代言产业链',
    quote: '从找水军刷评论到伪造使用效果，这条灰色产业链的年产值高达数十亿，而消费者完全被蒙在鼓里。',
    source: '前品牌营销总监',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20product%20photography%20with%20hidden%20dark%20secrets%2C%20deceptive%20beauty%2C%20dark%20crimson%20atmosphere%2C%20editorial%20investigation%20style%2C%20dramatic%20lighting%20and%20shadows&width=600&height=750&seq=exclusive-03&orientation=portrait',
    category: 'bagua-neimu',
  },
];

export const stats = [
  { value: '1280', unit: '万+', label: '月活跃用户' },
  { value: '5600', unit: '+', label: '累计爆料' },
  { value: '98', unit: '%', label: '爆料准确率' },
];

export const teamMembers = [
  { name: '黑料特工小K', role: '首席调查记者', description: '深耕网红圈五年，拥有丰富的一手信息源，曾独家揭露多起重大网红塌房事件。' },
  { name: '吃瓜前线阿喵', role: '高级内容编辑', description: '十年娱乐媒体从业经验，擅长从海量信息中挖掘有价值的线索，以严谨的求证态度著称。' },
  { name: '圈内老炮儿', role: '特约评论员', description: '前MCN机构高管，对网红行业运作机制了如指掌，提供深度行业分析和独家内幕解读。' },
  { name: '数据侦探老张', role: '数据调查员', description: '数据分析专家，擅长通过大数据挖掘发现隐藏在表面之下的真相，已协助完成多起调查报道。' },
];

export const faqs = [
  {
    question: '每日大赛黑料网的爆料信息可靠吗？',
    answer: '我们坚持以事实为依据，所有爆料均经过多方交叉验证后才予以发布。我们的编辑团队由资深娱乐记者和行业内部人士组成，确保每一条信息的真实性和准确性。',
  },
  {
    question: '如何向每日大赛黑料网提供线索？',
    answer: '您可以通过页面底部的联系方式发送邮件至我们的爆料邮箱，或通过社交媒体私信提交线索。我们承诺对所有线人身份严格保密，并根据线索价值提供相应奖励。',
  },
  {
    question: '每日大赛黑料网的内容更新频率如何？',
    answer: '我们保持7×24小时全天候更新，编辑团队实时监控各大平台和圈内动态，确保您在第一时间获取最新、最热的爆料资讯。',
  },
  {
    question: '每日大赛黑料网app在哪里下载？',
    answer: '每日大赛黑料网App目前支持iOS和Android双平台，您可在App Store和各大安卓应用市场搜索"每日大赛黑料"进行下载，获取更流畅的阅读体验和推送通知功能。',
  },
  {
    question: '如何与每日大赛黑料网进行商务合作？',
    answer: '我们欢迎各类商务合作洽谈，包括广告投放、内容合作、品牌联动等形式。请通过页面底部的商务合作邮箱与我们联系，我们将在24小时内回复。',
  },
];